export default {
  name: 'easyboss',
  env: 'pre',
  baseURL: `https://pre.easyboss.com`,
  appId: 'wxbc7c3c0d99d32e78',
  wxMpRegisterUrlBase: `https://m-pre.easyboss.com`,
}
